import React, { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative overflow-hidden py-12 md:py-20">
      <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
        <div className="glass relative overflow-hidden rounded-[24px] px-8 py-14 md:px-16 md:py-20">
          <div className="mesh-bg">
            <div className="mesh-blob" style={{ width: 320, height: 320, background: "#F28C82", top: -80, left: -60 }} />
            <div className="mesh-blob" style={{ width: 300, height: 300, background: "#B8E3D9", bottom: -80, right: -40 }} />
          </div>
          <div className="relative z-10">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F28C82]">Stay in the loop</p>
            <h2 className="mt-4 font-heading text-3xl font-medium tracking-tight text-[#4B2E5A] md:text-4xl">
              Get early access to Naari
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-[#4B2E5A]/60 md:text-lg">
              Occasional updates on our products, decision intelligence, and the future of everyday life. No noise.
            </p>
            <form onSubmit={submit} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
              <input
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="w-full rounded-full border border-[#4B2E5A]/15 bg-white/90 px-6 py-4 text-[#4B2E5A] outline-none focus:border-[#F28C82]"
              />
              <button
                data-testid="newsletter-submit-btn"
                type="submit"
                disabled={loading}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#4B2E5A] px-7 py-4 text-sm font-medium text-[#FCFAF7] transition-all hover:bg-[#4B2E5A]/90"
              >
                {loading ? "Subscribing..." : "Subscribe"} <ArrowRight className="h-4 w-4" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
